/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Page_DescriptionInputs */

const de_orders_page_description = /** @type {(inputs: Orders_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersicht Ihrer Bestellungen und Rücksendungen.`)
};

/** @type {(inputs: Orders_Page_DescriptionInputs) => LocalizedString} */
const en_orders_page_description = de_orders_page_description;

/**

* @param {Orders_Page_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const orders_page_description = /** @type {((inputs?: Orders_Page_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Page_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_orders_page_description(inputs)
	return en_orders_page_description(inputs)
});